import React from 'react';
import {Input} from 'antd';

import {FormFieldInputWrapperClasses, FormFieldWrapperClasses} from '../';
import {trb} from '../../../Utilities';

export const InputPasswordFormField = (props) => {
    const title = props.title,
        titleWithoutTranslate = props.titleWithoutTranslate,
        className = props.className,
        size = props.size,
        inline = props.inline,
        placeholder = props.placeholder,
        disabled = props.disabled;

    const meta = props.meta;

    return <div className={FormFieldWrapperClasses(className, inline)}>
        {title && <div className={inline ? 'form-field-title col-12 col-md-3 text-left text-md-right pb-2 pb-md-0' : 'form-field-title col-12'}>{titleWithoutTranslate ? title : trb(title)}</div>}
        <div className={FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline)}>
            <Input.Password
                autoComplete="none"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck="off"
                size={size}
                placeholder={trb(placeholder)}
                disabled={disabled}
                name={props.input.name}
                value={props.input.value}
                onChange={props.input.onChange}
                type="password"
                autoFocus={props.autoFocus}
                suffix={props.suffix}
                maxLength={props.maxLength}
            />
        </div>
        <div className={inline ? 'form-field-error col-12 col-md-3' : 'form-field-error col-12'}>{meta.touched && (meta.error || meta.submitError)}</div>
    </div>
};
